/**
 * Coarse mobile detection used to gate the Web Speech API dictation control.
 *
 * The browser Web Speech API is unreliable on mobile (iOS Safari ignores
 * `continuous`, drops interim results, and cuts off per phrase), which turns the
 * hook's auto-restart loop into a broken stutter. We hide the mic on mobile
 * rather than ship a silently-broken control. Revisit if/when a server-side STT
 * path (MediaRecorder → Edge Function) makes mobile viable.
 */
export function isProbablyMobile(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false

  const coarsePointer =
    typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches
  const mobileUa = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

  return coarsePointer || mobileUa
}
